var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehiclesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_car-alt",
    "data-name": "solid car-alt",
    d: "M22.847,71.726l-.585-1.464-1.038-2.6A5.8,5.8,0,0,0,15.807,64H9.193a5.806,5.806,0,0,0-5.416,3.667l-1.038,2.6-.585,1.464A3.326,3.326,0,0,0,0,74.833v2.5a3.306,3.306,0,0,0,.833,2.184v2.816A1.667,1.667,0,0,0,2.5,84H4.167a1.667,1.667,0,0,0,1.667-1.667V80.667H19.167v1.667A1.667,1.667,0,0,0,20.833,84H22.5a1.667,1.667,0,0,0,1.667-1.667V79.517A3.3,3.3,0,0,0,25,77.333v-2.5A3.326,3.326,0,0,0,22.847,71.726ZM6.871,68.9a2.5,2.5,0,0,1,2.321-1.571h6.615A2.5,2.5,0,0,1,18.129,68.9l1.038,2.6H5.833Zm-2.7,8.418a1.661,1.661,0,1,1,0-3.323,3.206,3.206,0,0,1,2.5,2.492C6.667,77.489,5.167,77.323,4.167,77.323Zm16.667,0c-1,0-2.5.166-2.5-.831A3.206,3.206,0,0,1,20.833,74a1.661,1.661,0,1,1,0,3.323Z",
    transform: "translate(0 -64)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclesIcon);
export default __webpack_public_path__ + "static/media/vehicles-icon.8319ffd0adc1ccdd3feb92adb97b9676.svg";
export { ForwardRef as ReactComponent };